import { ContentPage } from '../page-factory/content-page';
import { whoWeArePage } from '../pages/page-the-camp.who-are-we';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(whoWeArePage);

export default function WhoAreWePage() {
  return <ContentPage {...whoWeArePage} />;
}
